export function isImageFile(path) {
    let newPath = ''
    try {
        const url = new URL(path);
        newPath = `${url.origin}${url.pathname}`;
    } catch (error) {
        return false; // No es una URL válida
    }
    // Lista de extensiones de imagen permitidas
    const imageExtensions = new Set([
      '.jpg', '.jpeg', '.png', '.gif',
      '.bmp', '.webp', '.svg', '.tiff',
      '.tif', '.ico', '.heic', '.heif'
    ]);
  
    // Lista de tipos MIME de imagen válidos
    const validMimeTypes = new Set([
      'image/jpeg',
      'image/png',
      'image/gif',
      'image/bmp',
      'image/webp',
      'image/svg+xml',
      'image/tiff',
      'image/x-icon',
      'image/heic',
      'image/heif'
    ]);
  
    // Verificar extensión del archivo
    const extension = newPath
      .slice(((newPath.lastIndexOf('.') - 1) >>> 0) + 2) // Maneja casos como .tar.gz
      .toLowerCase();
  
    if (!imageExtensions.has(`.${extension}`)) {
      return false;
    }
  
    // Verificación opcional de tipo MIME (requiere acceso al archivo)
    // Si tienes acceso al buffer del archivo:
    if (typeof File !== 'undefined' && newPath instanceof File) {
      return validMimeTypes.has(newPath.type);
    }
  
    return true;
  }
  